<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M2.667 6.667c0-.736.597-1.333 1.333-1.333h24c.737 0 1.334.597 1.334 1.333v11.611A3.322 3.322 0 0028 18.001H4c-.474 0-.925.099-1.333.277V6.668zm0 14.667c0-.736.597-1.333 1.333-1.333h24c.737 0 1.334.597 1.334 1.333v4c0 .736-.597 1.333-1.334 1.333H4a1.333 1.333 0 01-1.333-1.333v-4zm24.333 2a1 1 0 11-2 0 1 1 0 012 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'hardwareHddFilled'
}
</script>
